module.exports = __webpack_public_path__ + "build/img/man.ef3cfac2.png";